import styled, { css } from 'styled-components'
import sktDefault from 'src/assets/images/mkt03/icon_skt.png'
import sktActive from 'src/assets/images/mkt03/icon_skt_on.png'
import ktActive from 'src/assets/images/mkt03/icon_kt_on.png'
import lgActive from 'src/assets/images/mkt03/icon_lg_on.png'
import ktDefault from 'src/assets/images/mkt03/icon_kt.png'
import lgDefault from 'src/assets/images/mkt03/icon_lg.png'
import { ButtonStyleType, CertsStyleType } from 'src/types/type'
import { mkt03CustomMedia, Mkt03responsiveWidth } from '.'

const PhoneVerificationWrap = styled.div<Omit<CertsStyleType, 'type'>>`
  ${Mkt03responsiveWidth};
  margin: 0 auto 16px auto;
`
const TelSelectorWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 13px;
  margin: 16px auto;

  ${mkt03CustomMedia.lessThan('midLayout')`
    gap: 13px;
 `}

  ${mkt03CustomMedia.greaterThan('midLayout')`
     gap: 10px;
  `}
`
export const TelCircleWrap = styled.div<{
  bgActive: boolean
  actColor: string
}>`
  display: flex;

  padding: 20px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border-radius: 60px;
  border: 1px solid #ccc;
  background: #fff;

  ${(props) =>
    props.bgActive &&
    css`
      border: 2px solid ${props.actColor};
    `}

  ${mkt03CustomMedia.lessThan('midLayout')`
      width: 90px;
      height: 90px;
   `}
  
    ${mkt03CustomMedia.greaterThan('midLayout')`
       width: 100px;
      height: 100px;
    `}
`
const Telecoms = styled.button<{ bgActive: boolean; actColor: string; oneTelStyle: boolean }>`
  display: flex;
  width: 60px;
  height: 60px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background-color: #fff;

  &.skt {
    background-image: url(${sktDefault});
  }
  &.kt {
    background-image: url(${ktDefault});
  }
  &.lg {
    background-image: url(${lgDefault});
  }

  ${(props) =>
    props.bgActive &&
    css`
      &.skt {
        background-image: url(${sktActive});
      }

      &.kt {
        background-image: url(${ktActive});
      }

      &.lg {
        background-image: url(${lgActive});
      }
    `}
`

const TelPhoneNumWrap = styled.div`
  display: block;
  
  > section {
    > span {
      color: red;
      font-size: 17px;
      line-height: 18px;
      margin-left: 48px;
    }
  }
`

const TelInput = styled.input<{ borderColor: string; backgroundColor: string; fontColor: string }>`
  width: 100%;
  height: 48px;
  padding: 20px;
  background-color: ${(props) => props.backgroundColor};
  border-radius: 12px;
  border: 1px solid #b3b3b3;
  font-size: 16px;
  margin-bottom: 15px;
  &:focus {
    background-color: #faffbd;
    border: none;
    outline: 1px solid ${(props) => props.borderColor};
  }

  overflow: hidden;
  color: ${(props) => props.fontColor}
  text-overflow: ellipsis;

  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`

const CertInput = styled.input`
  display: flex;
  width: 100%;
  height: 48px;
  padding: 10px 16px;

  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  border-radius: 12px;

  text-overflow: ellipsis;
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  color: #000;
  background-color: #faffbd;
  border: none;
  outline: 1px solid rgb(255, 41, 66);
`

const CertInputContainer = styled.div`
  display: flex;
  position: relative;
`

const TimerWrap = styled.span`
  position: absolute;
  right: 90px;
  color: #f2373e;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 50px;
`

const CertSubmitBtn = styled.button<ButtonStyleType>`
  cursor: pointer;
  width: 100%;
  height: 48px;
  background: ${(props) => props.disabled ? '#E6E6E6' : props.backgroundColor};
  border-radius: ${(props) => props.borderRadius};
  margin: 0 0 10px 0;
  color: ${(props) => props.fontColor ?? '#fff'};
  padding: 0px 16px;
  font-weight: ${(props) => props.fontWeight};
  font-size: ${(props) => props.fontSize};
  letter-spacing: ${(props) => props.letterSpacing};

  border-radius: 12px;

  color: #fff;
  text-align: center;

  font-family: ${({ theme }) => theme.fontFamily};
  font-style: normal;
  line-height: 24px;
  
  -webkit-tap-highlight-color: transparent;
`
const ReCertBtn = styled.button`
  position: absolute;
  right: 0px;
  border: none;
  padding: 5px 8px;
  margin: 10px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 30px;
  white-space: nowrap;
  background-color: #FF4545;

  color: #FFFFFF;
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;

  &:active {
    background-color: #D13B3B;
  }
`


export {
  TelSelectorWrap,
  Telecoms,
  TelPhoneNumWrap,
  TelInput,
  CertInput,
  CertInputContainer,
  TimerWrap,
  CertSubmitBtn,
  PhoneVerificationWrap,
  ReCertBtn,
}
